import { DatePipe } from '@angular/common';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'dateOrDefault'})
export class DateOrDefaultPipe implements PipeTransform {
  transform(value: any, pattern?: string, defaultString?: string): string {
    let datePipe: DatePipe = new DatePipe('en');
    let dateString: string = '—'; // default to an em dash

    if (typeof defaultString !== 'undefined') {
      dateString = defaultString; // override default
    }

    if (value !== null && typeof value !== 'undefined' && value !== '' && value !== '0') {
      dateString = datePipe.transform(value, pattern);
    }

    return dateString;
  }
}
